// extracted by mini-css-extract-plugin
module.exports = {"h4":"paymentMethods_h4__L5wZG","ctaTitle":"paymentMethods_ctaTitle__VBVhB"};